// Resume page
const EducationData = [
  {
    time: '2021.8 - 2023.5',
    name: 'Georgetown University',
    desc: 'Master of Science in Data Science & Analytics, Washington, D.C., USA',
    points: [
      'GPA: 4.0 / 4.0',
      'Core Courses: Big Data &Cloud Computing, Prob Modeling/Computing, Database Management',
    ],
  },
  {
    time: '2017.9 - 2021.6',
    name: 'East China University of Science and Technology',
    desc: 'Bachelor of Economics, Shanghai, China',
    points: [
      'Honors: Outstanding Graduate (Top 10%), 2019-2020 Academic First-class Scholarship (4th/98), 2020-2021 Academic Second-class Scholarship (11th/98), Outstanding Student Leader, Innovative Scholarship',
    ],
  },
]

const InternshipData = [
  {
    time: '2022.9 - current',
    name: 'Plan-et Systems Consultant, LLC',
    desc: 'Data Analytics Intern, California, USA',
    points: [
      'Database Management: Maintained real-time data of ESG industry and built Tableau dashboards',
      'Machine Learning: Analyzed Ocean Health Index data in US economic zones and influence on tourism industries',
    ],
  },
  {
    time: '2020.7 - 2020.8',
    name: 'Ipsos',
    desc: 'Quantitative Analyst Intern, FMCG Team, Shanghai, China',
    points: [
      'Database Management: Used MySQL to manage Sephora’s 10000-level survey data, established key criteria and calculated brand health score (brand awareness, brand image index and omnichannel conversion rate) to find important factors affecting brand health, which provides Sephora with decision-making reference',
      "Customer & Product Analysis: Utilized R to classify consumers' preferences from the perspective of geography, age and consumption level; Built user files and provided data support for Sephora's promotional programs in different consumer groups",
      'AB Testing: Evaluated Chips Ahoy Bar new design using A/B testing, issued consumer tests, analyzed consumer data and gave product design decision suggestions, which increased ROI in 5%',
      'Business Support: Composed bilingual reports for Sephora on strategy recommendations using interactive data visualizations',
    ],
  },
  {
    time: '2021.1 - 2021.3',
    name: 'Deloitte Consulting',
    desc: 'Assistant Consultant & Research Intern, TMT Team, Shanghai, China',
    points: [
      'Statistical Analysis: Utilized linear regression to assess and predict the value of Chinese listed AI companies. Conducted TMTindustry desk researches to calculate the Chinse SME AI market size',
      'Data Collection: Organized interviews with CTOs from 20 AI companies and collected first-hand data',
      'Build Dashboards: Produced well-illustrated report with dashboards (built with R and Tableau) and presented 6+recommendations/key takeaways to Intel’s product and market strategy',
    ],
  },
]

const ProjectData = [
  {
    time: '2022.5',
    name: 'E-commerce Analysis – Big Data Driven Machine Learning Project',
    desc: 'Utilized PySpark and SQL Query to analyze millions of e-commerce data in Taobao App',
    points: [
      'Supervised Learning: Used Logistic Regression, XGBoost and Random Forest algorithms to build classification models on predicting Click Through Rate of advertisements in different user groups',
      'Metrics Tracking: Monitor metrics including DAU, PV, Conversion Rate and proposed solution strategies for abnormal metrics',
    ],
  },
  {
    time: '2022.3',
    name: 'HIV Healthcare global supply chain prediction analysis - Python analysis project',
    desc: 'Connected USAID API and applied machine learning methods for supply chain analysis',
    points: [
      'Feature Engineering: Selected data of important dimensions by principal component analysis on supply & demand sides',
      'Machine Learning: Built models like Bagging to classify delayed goods. Combined feature importance analysis with data visualization to make recommendations on improving the efficiency of HIV drug supply chain',
    ],
  },
]

export const CVData = [
  { title: 'Education', data: EducationData },
  { title: 'Professional Experience', data: InternshipData },
  { title: 'Project Experience', data: ProjectData },
]
